import React, {useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import AddLetterMaintenance from './AddLetterMaintenance';
import SearchLetterMaintenance from './SearchLetterMaintenance';
import LetterMaintenanceUsage from './LetteMaintenanceUsage';
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    borderRadius: '5px',
  },
  padding: {
    padding: theme.spacing(3),
  },
  demo1: {
    backgroundColor: '#296bff',
    color: 'white',
    borderRadius: '6px',
  },
}));

export default function LookupMaintenanceTabs() {
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const [editExisting, setEditExisting] = useState(false);
  const [lettermaintainanceUsage, setLetterMaintenanceData] = useState([]);

  return (
    <div className={classes.root}>
      <div className={classes.subContent}>
        {value === 0 ? (
          <SearchLetterMaintenance
            setValue={setValue}
            setEditExisting={setEditExisting}
            setLetterMaintenanceData={setLetterMaintenanceData}
          />
        ) : null}
      </div>
      <div className={classes.subContent}>
        {value === 1 ? (
          <AddLetterMaintenance editExisting={editExisting} setValue={setValue} />
        ) : null}
      </div>
      <div className={classes.subContent}>
        {value === 2 ? (
          <LetterMaintenanceUsage
            setValue={setValue}
            lettermaintainanceUsage={lettermaintainanceUsage}
          />
        ) : null}
      </div>
    </div>
  );
}
